import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "col-submenu" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", { class: "submenu-header" }, "Fysieke belasting", -1)
const _hoisted_3 = { class: "submenu" }
const _hoisted_4 = { class: "submenu" }

import {pageHelper} from '@/utils/pageHelper';
	import IconStatus from '@/components/icons/IconStatus';
	import SkeletonSubmenuItem from '@/components/generic/SkeletonSubmenuItem';
	import NumberUtils from '@/utils/numberUtils';
	import {checkStoreMethod} from '@/store/check/checkStore';
	import {PHYSICAL_STRAIN_STORE} from '@/store/check/physicalstrain/physicalStrainMethods';
	import BackLink from '@/components/decorations/BackLink.vue';
	import {computed, onMounted, ref} from 'vue';
	import {useRoute} from 'vue-router';
	import {IFunctionGroup} from '@/types/check/IFunctionGroup';
	import {useStore} from 'vuex';

	interface Props {
		functionGroups?: IFunctionGroup[]
	}

	
export default /*#__PURE__*/_defineComponent({
  __name: 'SidebarPhysicalStrain',
  props: {
    functionGroups: { default: () => [] }
  },
  setup(__props: any) {

const props = __props;

	

	const loading = ref(false);
	const loadedFunctionGroups = ref<IFunctionGroup[]>([]);

	const route = useRoute();
	const store = useStore();
	const companyId = computed(() => NumberUtils.stringToNumber(route.params.companyId));
	const currentFunctionGroups = computed(() => {
		if (props.functionGroups?.length > 0) {
			return props.functionGroups;
		}
		return loadedFunctionGroups.value;
	});

	const getRouterLinkForFunctionGroup = (functionGroup: IFunctionGroup) => ({
		name: pageHelper.PAGE_PHYSICAL_RESULTS_FUNCTION_GROUP,
		params: {
			companyId: companyId.value,
			functionGroupIdOrScriptKey: functionGroup.id
		}
	});

	const loadFunctionGroups = async () => {
		const isResultOverviewPage = route.name === pageHelper.PAGE_PHYSICAL_RESULTS;

		if (props.functionGroups?.length > 0 || isResultOverviewPage) {
			return;
		}

		loading.value = true;

		await store.dispatch(PHYSICAL_STRAIN_STORE.GET_RESULTS, companyId.value)
			.then(results => loadedFunctionGroups.value = results.checkSections)
			.catch(() => store.dispatch(checkStoreMethod.SET_WARNING, 'Functiegroepen konden niet worden geladen.'))
			.finally(() => loading.value = false);
	};

	onMounted(() => loadFunctionGroups());

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("ul", _hoisted_3, [
      _createElementVNode("li", null, [
        _createVNode(BackLink)
      ])
    ]),
    _createElementVNode("ul", _hoisted_4, [
      (loading.value)
        ? (_openBlock(), _createBlock(_unref(SkeletonSubmenuItem), { key: 0 }))
        : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(currentFunctionGroups.value, (group) => {
            return (_openBlock(), _createElementBlock("li", {
              key: group.id
            }, [
              _createVNode(_component_router_link, {
                to: getRouterLinkForFunctionGroup(group)
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IconStatus), {
                    color: group.status
                  }, null, 8, ["color"]),
                  _createElementVNode("span", null, _toDisplayString(group.name), 1)
                ]),
                _: 2
              }, 1032, ["to"])
            ]))
          }), 128))
    ])
  ]))
}
}

})